import { SuiteManifest } from '../manifest';
import { coreRoutes } from './routes';
import { coreNavItems } from './nav';

export const coreManifest: SuiteManifest = {
  id: 'core',
  name: 'Core & Foundation',
  basePath: '/core',
  icon: 'layers',
  description: 'Underlying foundation for Directory, RBAC, Custom Objects, Automations, Email Domain, Communication, and System Governance.',
  nav: coreNavItems,
  routes: coreRoutes,
};

export default coreManifest;
